import { DEFAULT_OG_IMAGE, SITE_NAME, SITE_URL } from "./seoConfig";

const setMetaTag = (key, content, attribute = "name") => {
  if (content == null || content === "") return;

  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
};

const setLinkTag = (rel, href, extra = {}) => {
  if (!href) return;

  let element = document.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
  Object.entries(extra).forEach(([attr, value]) => {
    element.setAttribute(attr, value);
  });
};

export const applySEO = ({
  title,
  description,
  keywords,
  path = "/",
  noIndex = false,
  image,
  type = "website",
  lang = "ar",
}) => {
  const pageTitle = title
    ? title.includes("|")
      ? title
      : `${title} | ${SITE_NAME}`
    : SITE_NAME;

  const canonicalUrl = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
  const robotsContent = noIndex ? "noindex, nofollow" : "index, follow";
  const ogImage = image?.startsWith("http")
    ? image
    : image
      ? `${SITE_URL}${image.startsWith("/") ? image : `/${image}`}`
      : DEFAULT_OG_IMAGE;

  document.title = pageTitle;
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";

  setMetaTag("description", description);
  if (keywords) setMetaTag("keywords", keywords);
  setMetaTag("robots", robotsContent);
  setMetaTag("googlebot", robotsContent);

  setMetaTag("og:title", pageTitle, "property");
  setMetaTag("og:description", description, "property");
  setMetaTag("og:url", canonicalUrl, "property");
  setMetaTag("og:type", type, "property");
  setMetaTag("og:site_name", SITE_NAME, "property");
  setMetaTag("og:image", ogImage, "property");
  setMetaTag("og:locale", lang === "ar" ? "ar_SY" : "en_US", "property");

  setMetaTag("twitter:card", "summary_large_image");
  setMetaTag("twitter:title", pageTitle);
  setMetaTag("twitter:description", description);
  setMetaTag("twitter:image", ogImage);

  setLinkTag("canonical", canonicalUrl);

  document
    .querySelectorAll('link[rel="alternate"][hreflang]')
    .forEach((el) => el.remove());
  ["ar", "en", "x-default"].forEach((hreflang) => {
    const element = document.createElement("link");
    element.setAttribute("rel", "alternate");
    element.setAttribute("hreflang", hreflang);
    element.setAttribute("href", canonicalUrl);
    document.head.appendChild(element);
  });
};
